export * from "./bounceRegisterAcceptedFilter.component";
